import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gray-50 border-b">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link to="/" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Refund Policy</h1>
          <p className="text-gray-600 mt-2">Last updated: January 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="space-y-8">
  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      1. Money-Back Guarantee
    </h2>
    <p className="text-gray-600 mb-3">
      MealGuide offers a <strong>14-day money-back guarantee</strong> starting from
      the date of your first paid subscription charge.
    </p>
    <p className="text-gray-600 mb-3">
      If you’re not satisfied with the service, you may request a refund within
      this period.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      2. Eligibility
    </h2>
    <p className="text-gray-600 mb-3">
      Refunds are subject to the following conditions:
    </p>
    <ul className="list-disc list-inside text-gray-600 space-y-1">
      <li>Refunds apply to the most recent billing period only</li>
      <li>Refund requests must be made within 14 days of being charged</li>
    </ul>
    <p className="text-gray-600 mb-3">
      No charges are made during the free trial. Refunds apply only after a paid
      subscription begins.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      3. How to Request a Refund
    </h2>
    <p className="text-gray-600 mb-3">
      To request a refund, contact:
    </p>
    <p className="text-gray-600 mb-3">
      <strong>support@getmealguide.com</strong>
    </p>
    <p className="text-gray-600 mb-3">
      Approved refunds are processed back to the original payment method and may
      take several business days to appear.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">
      4. Abuse of Refunds
    </h2>
    <p className="text-gray-600 mb-3">
      Repeated refund requests may result in account restrictions or denial of
      future refunds.
    </p>
  </section>

  <section>
    <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Contact</h2>
    <p className="text-gray-600 mb-3">
      For questions about refunds, contact:
    </p>
    <p className="text-gray-600 mb-3">
      <strong>support@getmealguide.com</strong>
    </p>
  </section>
</div>

      </div>

      {/* Footer */}
      <footer className="bg-gray-50 border-t mt-12">
        <div className="max-w-4xl mx-auto px-4 py-6 text-center text-gray-600">
          © 2026 MealGuide. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
